export default __webpack_public_path__ + "static/last-min-flights-f72b1b0b9eca8d51cfd132c2c296208f.jpg";